import {
  FETCH_IMPORTED_INVENTORY_REQUEST,
  FETCH_IMPORTED_INVENTORY_SUCCESS,
  FETCH_IMPORTED_INVENTORY_FAILURE,
  UPLOAD_CSV_REQUEST,
  UPLOAD_CSV_SUCCESS,
  UPLOAD_CSV_FAILURE,
  UPDATE_IMPORTED_INVENTORY_REQUEST,
  UPDATE_IMPORTED_INVENTORY_SUCCESS,
  UPDATE_IMPORTED_INVENTORY_FAILURE,
  DELETE_IMPORTED_INVENTORY_REQUEST,
  DELETE_IMPORTED_INVENTORY_SUCCESS,
  DELETE_IMPORTED_INVENTORY_FAILURE,
  DELETE_ALL_IMPORTED_INVENTORY_REQUEST,
  DELETE_ALL_IMPORTED_INVENTORY_SUCCESS,
  DELETE_ALL_IMPORTED_INVENTORY_FAILURE
} from '../../types/importedInventory/importedInventoryTypes';

const initialState = {
  importedInventory: [],
  loading: false,
  error: null,
  uploadSuccess: false
};

const importedInventoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IMPORTED_INVENTORY_REQUEST:
    case UPLOAD_CSV_REQUEST:
    case UPDATE_IMPORTED_INVENTORY_REQUEST:
    case DELETE_IMPORTED_INVENTORY_REQUEST:
    case DELETE_ALL_IMPORTED_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        uploadSuccess: false
      };
    case FETCH_IMPORTED_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        importedInventory: action.payload || [],
        error: null
      };
    case UPLOAD_CSV_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadSuccess: true,
        error: null
      };
    case UPDATE_IMPORTED_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case DELETE_IMPORTED_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };
    case DELETE_ALL_IMPORTED_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        importedInventory: [],
        error: null
      };
    case FETCH_IMPORTED_INVENTORY_FAILURE:
    case UPLOAD_CSV_FAILURE:
    case UPDATE_IMPORTED_INVENTORY_FAILURE:
    case DELETE_IMPORTED_INVENTORY_FAILURE:
    case DELETE_ALL_IMPORTED_INVENTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || 'An error occurred',
        uploadSuccess: false
      };
    default:
      return state;
  }
};

export default importedInventoryReducer; 